import { Expose } from "class-transformer";

export class CreateUserHasFavoriteWarehouseDto {
  @Expose()
  warehouseId: string;
}
